import React from "react";

const DataUserContext = React.createContext(null);

export default DataUserContext;
